export const staffpayroll = [
    {
        view: "View Payslip",
        id: "8198",
        salaryFor: "Mar - 2025",
        date: "04 Mar 2025",
        paymentMethod: "Cash",
        netSalary: "RM20,000",
        details:"View Payslip",
        key:1
    },
      {
        view: "View Payslip",
        id: "8197",
        salaryFor: "Mar - 2025",
        date: "05 Mar 2025",
        paymentMethod: "Cheque",
        netSalary: "RM19,000",
        details:"View Payslip",
        key:2
    },
      {
        view: "View Payslip",
        id: "8196",
        salaryFor: "Feb - 2025",
        date: "05 Mar 2025",
        paymentMethod: "Cash",
        netSalary: "RM19,500",
        details:"payslip",
        key:3
    },
      {
        view: "View Payslip",
        id: "8198",
        salaryFor: "Jan - 2025",
        date: "06 Feb 2025",
        paymentMethod: "Cash",
        netSalary: "RM20,000",
        details:"payslip",
        key:4
    },
      {
        view: "View Payslip",
        id: "8194",
        salaryFor: "Dec - 2024",
        date: "03 Jan 2025",
        paymentMethod: "Cheque",
        netSalary: "RM19,480",
        details:"payslip",
        key:5
    },
      {
        view: "View Payslip",
        id: "8193",
        salaryFor: "Nov - 2024",
        date: "05 Dec 2024",
        paymentMethod: "Cheque",
        netSalary: "RM19,480",
        details:"payslip",
        key:6
    },
      {
        view: "View Payslip",
        id: "8192",
        salaryFor: "Oct - 2024",
        date: "03 Nov 2024",
        paymentMethod: "Cheque",
        netSalary: "RM19,480",
        details:"payslip",
        key:7
    },
      {
        view: "View Payslip",
        id: "8191",
        salaryFor: "Sep - 2024",
        date: "04 Oct 2024",
        paymentMethod: "Cheque",
        netSalary: "RM18,000",
        details:"payslip",
        key:8
    },
      {
        view: "View Payslip",
        id: "8190",
        salaryFor: "Aug - 2024",
        date: "06 Sep 2024",
        paymentMethod: "Cheque",
        netSalary: "RM20,000",
        details:"payslip",
        key:9
    },
      {
        view: "View Payslip",
        id: "8189",
        salaryFor: "Jul - 2024",
        date: "05 Aug 2024",
        paymentMethod: "Cheque",
        netSalary: "RM20,000",
        details:"payslip",
        key:10
    }
]
